import React from 'react';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import logo from '../assets/logo.svg';

interface ILayoutProps {
  children: React.ReactNode;
}

export default ({ children }: ILayoutProps) => {
  return (
    <div className="app">
      <AppBar color="primary">
        <Toolbar>
          <Typography style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            <img width={75} src={logo} alt="Dish Netowork" />
            <span style={{marginLeft: 20}}>Cloud Whitelist Managment</span>
          </Typography>
        </Toolbar>
      </AppBar>
      <main>
        {children}
      </main>
    </div>
  );
};